import styles from './Button.module.scss';

const Button = (props) => 
{
    return (        
        <button onClick={props.trigger} className={styles[props.style]}>{props.children}</button> 
    );
}

export default Button;